import qs from 'qs';
import type { TaskFormTemplatesRequest } from './TaskFormState';
export const PAGED_PAGE_SIZE = 100;
const DEFAULT_SORT_KEY = 'id';

/**
 * Backend expects `sortQuery` as one or more JSON-serialized
 * `{sortKeySelector, sortOrder}` objects sent as repeated query params.
 * Returns at least one sort directive — endpoint marks the field as required.
 */
export const buildSortQuery = (
  keySelector?: string,
  order?: string,
): string | string[] => {
  const selector = keySelector?.trim() || DEFAULT_SORT_KEY;
  return JSON.stringify({
    sortKeySelector: selector,
    sortOrder: order || 'Desc',
  });
};

export const repeatSerializer = (params: Record<string, unknown>) =>
  qs.stringify(params, { arrayFormat: 'repeat' });

export const buildTaskFormTemplatesRequestConfig = (
  request: TaskFormTemplatesRequest | undefined,
) => {
  const {
    SortKeySelector = 'name',
    SortOrder = 'Asc',
    PageIndex = 0,
    PageSize = PAGED_PAGE_SIZE,
    ...filters
  } = request ?? {};
  const params: Record<string, unknown> = {
    ...filters,
    PageIndex,
    PageSize,
    sortQuery: buildSortQuery(SortKeySelector, SortOrder),
  };

  return {
    params,
    paramsSerializer: repeatSerializer,
  };
};
